import actions from "./actions";
import UserStateRecord from "@infinode/records/reducers/UsersStateRecord";
import infiAuthActions from "../infiAuth/actions";
import reducerUtils from "../reducerUtils";

export default function usersReducers(state = UserStateRecord(), action) {
  switch (action.type) {
    case infiAuthActions.INFI_LOGIN_SUCCESS: {
      return state.set("loginUserId", action.userId);
    }
    case infiAuthActions.INFI_LOGOUT: {
      return state.set("loginUserId", null);
    }
    case infiAuthActions.INFI_LOGIN_REQUEST: {
      return state.set("loginUserId", null);
    }
    case actions.GET_USER_REQUEST:
      return reducerUtils.getRequestState(state);
    case actions.GET_USER_SUCCESS:
      return state.withMutations(rm => {
        rm.set("loading", false);
        rm.setIn(["users", action.user.id], action.user);
      });
    case actions.GET_USER_ERROR:
      return state.merge({ loading: false, error: action.error });
    default:
      return state;
  }
}
